import React from 'react'
import styled from 'styled-components'
import Albums from '../../molecules/Dashboard/HomePage/Albums'
import { device } from '../../atoms/Utlis/media'

const AlbumsPageContainer = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background:
    radial-gradient(ellipse 70% 40% at 0% 0%, rgba(201, 77, 170, 0.05), transparent 55%),
    radial-gradient(ellipse 50% 35% at 100% 0%, rgba(255, 201, 81, 0.06), transparent 50%),
    #f8fafc;

  @media ${device.tablet} {
    padding: 16px;
  }
`

const AlbumsPage: React.FC = () => {
  return (
    <AlbumsPageContainer>
      <Albums />
    </AlbumsPageContainer>
  )
}

export default AlbumsPage
